import {Component, HostBinding} from '@angular/core';
import {WebStompService} from '../../web-stomp/web-stomp.service';

@Component({
  selector: 'app-web-stomp-info',
  templateUrl: './web-stomp-info.component.html',
})
export class WebStompInfoComponent {
  @HostBinding('class.header-menu-item') webStomp = true;

  constructor(
    public webStompService: WebStompService
  ) {
  }
}
